import { createSelector } from '@reduxjs/toolkit';
import getIn from 'transmute/getIn';
import { getWidgetUiState } from './getWidgetUiState';
export const getIsOpen = createSelector([getWidgetUiState], getIn(['open']));